import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { XpoChipsModule } from '@xpo-ltl/ngx-ltl-core/chips';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { BooleanCellRendererComponent } from './cell-renderers/boolean-cell-renderer/boolean-cell-renderer.component';
import { CurrencyCellRendererComponent } from './cell-renderers/currency-cell-renderer/currency-cell-renderer.component';
import { StatusCellRendererComponent } from './cell-renderers/status-cell-renderer/status-cell-renderer.component';
import { BulkResultComponent } from './components/bulk-result/bulk-result.component';
import { XpoStatusIndicatorModule } from '@xpo-ltl/ngx-ltl-core/status-indicator';
import { GridAppliedFiltersComponent } from './components/grid/grid-applied-filters/grid-applied-filters.component';
import { AppliedFiltersDisplayPipe } from './components/grid/grid-applied-filters/helper/applied-filter.pipe';
import { XpoAgGridModule } from '@xpo-ltl/ngx-ag-grid';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { AgGridModule } from 'ag-grid-angular';
import { GridProgramsCellRendererComponent } from './cell-renderers/obi-incentive-programs-cell-renderer/grid-programs-cell-renderer.component';
import { NotAuthorizedComponent } from './dialog/not-authorized/not-authorized.component';
import { AuthRedirectComponent } from './components/auth-redirect/auth-redirect.component';
import { BackdateDialogComponent } from './dialog/backdate-dialog/backdate-dialog.component';
import { ExpireDialogComponent } from './dialog/expire-dialog/expire-dialog.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ObiIncentiveIdCellRendererComponent } from './cell-renderers/obi-incentive-id-cell-renderer/obi-incentive-id-cell-renderer.component';
import { GridSkeletonComponent } from './components/grid/grid-skeleton/grid-skeleton.component';
import { RenewDialogComponent } from './dialog/renew-dialog/renew-dialog.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { XpoErrorPagesModule } from '@xpo-ltl/ngx-ltl-core/error-pages';
import { UserRamRoleSelectionComponent } from './dialog/user-ram-role-selection/user-ram-role-selection.component';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { XpoGridToolbarModule } from '@app/_reusable/ngx-grid/projected-features/toolbar';

@NgModule({
  declarations: [
    // Components
    BulkResultComponent,
    GridProgramsCellRendererComponent,
    CurrencyCellRendererComponent,
    BooleanCellRendererComponent,
    StatusCellRendererComponent,
    ObiIncentiveIdCellRendererComponent,
    GridAppliedFiltersComponent,
    BackdateDialogComponent,
    ExpireDialogComponent,
    NotAuthorizedComponent,
    AuthRedirectComponent,
    // Pipes/Directives
    AppliedFiltersDisplayPipe,
    GridSkeletonComponent,
    RenewDialogComponent,
    UserRamRoleSelectionComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    XpoIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatChipsModule,
    XpoChipsModule,
    XpoStatusIndicatorModule,
    MatTooltipModule,
    XpoErrorPagesModule,
    XpoAgGridModule,
    XpoGridToolbarModule,
    MatButtonModule,
    XpoButtonModule,
    XpoDialogModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    AgGridModule.withComponents([]),
    // Pipes/Directives
  ],
  exports: [
    // Components
    BulkResultComponent,
    GridProgramsCellRendererComponent,
    GridAppliedFiltersComponent,
    UserRamRoleSelectionComponent,
    // Pipes/Directives
    AppliedFiltersDisplayPipe,
    // Modules
    XpoChipsModule,
    MatChipsModule,
  ],
  // providers:
})
export class SharedModule {}
